import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import { motion } from 'framer-motion';
import { useSelector } from 'react-redux';
import Alert from 'components/Alert';
import { useAction, useCountdown, useProgressSuccess } from 'hooks';
import messages from '../../messages';
import * as actions from '../../actions';
import * as selectors from '../../selectors';
import styles from './ConfirmDismissFilteredNotificationsAlert.pcss';
const ConfirmDismissFilteredNotificationsAlert = ()=>{
    useStyles(styles);
    const isDismissInProgress = useSelector(selectors.isDismissFilteredNotificationsInProgress);
    const hasError = useSelector(selectors.hasDismissFilteredNotificationsErrors);
    const confirm = useAction(actions.dismissFilteredNotificationConfirm);
    const cancel = useAction(actions.dismissFilteredNotificationCancel);
    const { seconds, isRunning, start, reset } = useCountdown(10);
    useEffect(()=>{
        if (isDismissInProgress) {
            start();
        } else {
            reset();
        }
    }, [
        isDismissInProgress
    ]);
    useProgressSuccess(isRunning && isDismissInProgress, hasError, confirm);
    if (!isDismissInProgress) return null;
    return /*#__PURE__*/ _jsx(motion.div, {
        initial: {
            height: 0
        },
        animate: {
            height: 'auto'
        },
        exit: {
            height: 0
        },
        transition: {
            ease: 'easeOut',
            duration: 0.3
        },
        className: styles.root,
        children: /*#__PURE__*/ _jsx(Alert, {
            id: "enrolledPatientWarning",
            type: "warning",
            message: messages.alerts.confirmDismissFilteredNotifications,
            messageValues: {
                time: seconds
            },
            onClose: cancel,
            actions: [
                {
                    message: messages.buttons.confirm,
                    action: confirm
                },
                {
                    message: messages.buttons.cancel,
                    action: cancel
                }
            ]
        })
    }, "ConfirmDismissFilteredNotificationsAlert");
};
export default ConfirmDismissFilteredNotificationsAlert;
